import React, { useState, useEffect, useRef } from 'react';
import { DashboardServiceApi } from "../../../services/stockFiltering/api";
import { Configuration } from "../../../services/stockFiltering/configuration"
import { set } from 'lodash';
import { useSelector } from 'react-redux';
import '../stockFiltering.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import { CSSTransition } from 'react-transition-group';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { faTrashCanList, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from "primereact/confirmdialog";
import { APIControl } from '../../../helpers/APIControl';
import { useTranslation } from 'react-i18next';



const ListBarStockFiltering = (props) => { // props: {selectedListBarItem}
    const dashboardServiceApi = new DashboardServiceApi(new Configuration({ basePath: process.env.REACT_APP_STOCK_FILTERING_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_STOCK_FILTERING_API_BASE_PATH));
    const token = useSelector((state) => state.auth?.token);
    const { t, i18n } = useTranslation();
    const toast = useRef(null);
    const [dashboardList, setDashboardList] = useState([]);
    const [activeCategoryId, setActiveCategoryId] = useState(null);
    const [editModalShow, setEditModalShow] = useState(false);
    const [addModalShow, setAddModalShow] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [editRenameInputValue, setEditRenameInputValue] = useState('');
    const [visibleAlert, setVisibleAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [editItemId, setEditItemId] = useState(0);

    useEffect(() => {
        getDashboardList();
    }, [props.listUpdated, props.isFinancial]);

    useEffect(() => {
      if (props.activeId) setActiveCategoryId(props.activeId);
    }, [props.activeId]);




    //#region API CALLS

    //#region Dashboard List
    const getDashboardList = () => {
        // setIsLoading(true);
        setActiveCategoryId(null);
        const culture = i18n.language;
        dashboardServiceApi.dashboardListGet(token, props.isFinancial, culture).then((res) => {
            console.log('getDashboardList: ', res);

        const list = res.data.items.filter((i) => i.filters.length);
            setDashboardList(list);

            const desired = list.find(i => i.id === props.activeId) ?? list[0];
            if (desired) {
                selectedListBarItem(desired);
            }
        
            props.listCount(list.filter(i => !i.system).length);

        }).catch((error) => {
            console.log('getDashboardList', error);
            // setIsLoading(false);
        });
    }
    //#endregion Dashboard List

    //#region Edit Rename 

    const clickEditRename = () => {

        if (editRenameInputValue === '') {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Liste adı boş olamaz', life: 3000 });
            return;
        }

        if (editItemId === 0) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Liste id boş olamaz', life: 3000 });
            return;
        }
        dashboardServiceApi.dashboardRenameGet(token, editItemId, editRenameInputValue).then((res) => {
            setEditModalShow(false);
            setEditRenameInputValue('');
            getDashboardList();
            toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Liste adı başarıyla değiştirildi', life: 3000 });

        }).catch((error) => {
            // console.log('getDashboardList', error);
            // setIsLoading(false);
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Liste adı değiştirilemedi', life: 3000 });
        });
    }

    //#endregion Edit Rename 

    //#region Delete 

    const deleteList = () => {
        if (editItemId === 0) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Liste id boş olamaz', life: 3000 });
            return;
        }

        dashboardServiceApi.dashboardDeleteGet(token, editItemId).then((res) => {
            
            // console.log('getDashboardList: ', res);
            // setDashboardList(res.data.items);
            setEditModalShow(false);
            setEditRenameInputValue('');
            getDashboardList();
            toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Liste başarıyla silindi', life: 3000 });

        }).catch((error) => {
            // console.log('getDashboardList', error);
            // setIsLoading(false);
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Liste silinemedi', life: 3000 });
        });
    }

    //#endregion Delete


    //#region Create New List

    const createWatchlist = () => {
        const name = inputValue;
        const culture = i18n.language;
        dashboardServiceApi.dashboardNewPost(token, name, culture).then((res) => {
            // console.log('createWatchlist: ', res);
            // setDashboardList(res.data.items);
            setAddModalShow(false);
            setInputValue('');
            getDashboardList();
            toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Liste başarıyla oluşturuldu', life: 3000 });



        }).catch((error) => {
            // console.log('createWatchlist', error);
            // setIsLoading(false);
        });
    }

    //#endregion Create New List

    //#endregion API CALLS

    //#region FUNCTIONS
    const selectedListBarItem = (item) => {
        // Remove duplicate screenerId entries, keeping only the first occurrence
        const uniqueFilters = item.filters.filter((filter, index, self) =>
            index === self.findIndex(f => f.screenerId === filter.screenerId)
        );

        // Update the item with unique filters
        const updatedItem = { ...item, filters: uniqueFilters };

        props.selectedListBarItem(updatedItem);
        setActiveCategoryId(item.id);
    }

    const clickEdit = (id, name) => {
        // console.log('clickEdit: ', id, name);
        setEditModalShow(true);
        setEditItemId(id);
        setEditRenameInputValue(name);

    }

    const handleEditRenameChange = (e) => {
        setEditRenameInputValue(e.target.value);
    };

    const deleteListAccept = () => {
        setVisibleAlert(true);
        setAlertMessage("'" + editRenameInputValue + "' İsimli listeyi silmek istediğinize emin misiniz?");
    };



    const handleChange = (e) => {
        setInputValue(e.target.value);
    };

    //#endregion FUNCTIONS

    return (
        <div className='stock-filtering-list-bar'>
            <Toast ref={toast} position="bottom-right" />
            <ConfirmDialog
                visible={visibleAlert}
                onHide={() => setVisibleAlert(false)}
                message={alertMessage}
                header="Uyarı"
                icon="pi pi-exclamation-triangle"
                accept={deleteList}
                acceptLabel="Evet"
                rejectLabel="İptal"
            />
            <div className='category-buttons-container m-t-20'>
                {
                    dashboardList.map((item, index) => (
                        <div
                            className={`category-button roboto-medium-14 ${activeCategoryId  === item.id ? 'active' : ''}`}
                            onClick={() => selectedListBarItem(item)}
                            key={item.id + index}
                        >
                            <span className='name'>
                                {item.name}
                            </span>


                            {activeCategoryId  === item.id && !item.id.includes('predefined') &&
                                <span className="edit-button" onClick={() => clickEdit(item.id, item.name)}>
                                    <FontAwesomeIcon className="icon" icon={faPencil} />
                                </span>
                            }
                        </div>
                    ))
                }
                {/* <div className='category-button yellow roboto-bold-14 p-l-20 p-r-20' onClick={() => setAddModalShow(true)}>
                    <i className="fas fa-plus" />
                    <label className='add'>Ekle</label>
                </div> */}
            </div>

            <CSSTransition in={editModalShow} timeout={3000} classNames="modal" unmountOnExit>

                <Modal dialogClassName="modal-edit-list" show={editModalShow} aria-labelledby="contained-edit-modal-title-vcenter" animation={true} backdrop="static" keyboard={false} centered>
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            <div className="modal-header-wrap">
                                <h6 className="m-0">{t('editList')}</h6>
                                <div
                                    className="modal-header-close"
                                    onClick={() => {
                                        setEditModalShow(false);
                                        setInputValue('');
                                    }}
                                >
                                    <FontAwesomeIcon icon={faXmark} />
                                </div>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col>
                                <div className="form-group">
                                    <input data-testid="listName-input" type="text" value={editRenameInputValue} onChange={handleEditRenameChange} className="form-control listName-input input" id="listName-input" placeholder="Liste Adı" />
                                </div>
                            </Col>
                        </Row>
                        <Button onClick={clickEditRename} className="modal-save-btn save-button">
                            {t('save')}
                        </Button>

                        <Button onClick={deleteListAccept} className="modal-delete-list-btn cancel-button">
                            {t('deleteList')}
                        </Button>
                    </Modal.Body>
                </Modal>
            </CSSTransition>

            <Modal dialogClassName="modal-create-list" show={addModalShow} aria-labelledby="contained-modal-title-vcenter" animation={true} backdrop="static" keyboard={false} centered>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <div className="modal-header-wrap">
                            <h6 className="m-0">{t('createNewList')}</h6>
                            <div className="modal-header-close" onClick={() => setAddModalShow(false)}>
                                <FontAwesomeIcon icon={faXmark} />
                            </div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <div className="form-group" data-testid="listName-input">
                                <input type="text" value={inputValue} onChange={handleChange}
                                    className="form-control input" id="listName-input" placeholder="Liste Adı" />
                            </div>
                        </Col>
                    </Row>
                    <Button onClick={createWatchlist} className="modal-save-btn save-button">
                        {t('save')}
                    </Button>
                </Modal.Body>
            </Modal>

        </div>
    );
}


export default ListBarStockFiltering;